import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
import { RolesEnum } from "../../shared/utils/RoutesEnum";

export const bookingOverviewGuard: CanActivateFn = () => {
  const getRoles = inject( AuthService ).getRoles();
  const checkRole = getRoles.includes( RolesEnum.AdminRole )
    || getRoles.includes( RolesEnum.ViewerRole )
    || getRoles.includes( RolesEnum.EditorRole );
  if( checkRole ) {
    return true;
  }
  else {
    inject( Router ).navigate( [inject( AuthService ).routeEnabledModule()] );
    return false;
  }
};
